import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  isLoading?: boolean;
  onConfirm: () => void;
  onConfirmText: string;
  content?: React.ReactNode | string;
}

export const NewConfirmDialog: React.FC<Props> = ({
  title,
  onClose,
  onConfirm,
  open,
  isLoading = false,
  onConfirmText,
  content = "",
}) => {
  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose}>
      <DialogTitle id="dialog-confirm-title">{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          color="primary"
          disabled={isLoading}
          onClick={onConfirm}
          startIcon={isLoading ? <CircularProgress size={20} /> : undefined}
        >
          {isLoading ? "Eliminando..." : onConfirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
